import { tenantCustomizationValues } from "./tenants";
import { TenantConfig } from "src/tenantCustomizations/TenantCustomizations";
import React from "react";
import deepMerge from "src/utils/deepMerge.ts";
import {
	DEFAULT_TENANT_CONFIG,
	DEFAULT_TENANT_CUSTOMIZATIONS,
} from "src/tenantCustomizations/defaultTenantCustomizations.ts";
import { TenantCustomizationsContext } from "./TenantCustomizationsContext";
import i18n from "i18next";
import { resolveTenantCustomizationName } from "./resolveTenantCustomizationName.ts";

export interface TenantCustomizationsContextProviderProps {
	children: React.ReactNode;
}

export const TenantCustomizationsContextProvider = ({
	children,
}: TenantCustomizationsContextProviderProps) => {
	const tenantName = resolveTenantCustomizationName(window.location.hostname);
	let customizations = tenantCustomizationValues[tenantName];
	if (customizations === undefined) {
		customizations = DEFAULT_TENANT_CUSTOMIZATIONS;
	}
	const tenantConfig = deepMerge(
		DEFAULT_TENANT_CONFIG,
		customizations.tenantConfig ?? {},
	) as TenantConfig;

	applyLocalizationOverrides(customizations.localizationOverrides);

	const resolvedCustomizations = {
		...DEFAULT_TENANT_CUSTOMIZATIONS,
		...customizations,
		tenantConfig: tenantConfig,
	};

	return (
		<TenantCustomizationsContext.Provider value={resolvedCustomizations}>
			{children}
		</TenantCustomizationsContext.Provider>
	);
};

const applyLocalizationOverrides = (overrides: Partial<Record<string, Record<string, string>>> | undefined) => {
	if (overrides == null) return;
	for (const [lang, keys] of Object.entries(overrides)) {
		i18n.addResourceBundle(lang, "translation", keys, true, true);
	}
};
